import uuid from 'react-native-uuid';

export const compareOrder = (a: { scopeId: number }, b: { scopeId: number }) => {
  if (a.scopeId < b.scopeId) {
    return -1;
  }
  if (a.scopeId > b.scopeId) {
    return 1;
  }
  return 0;
};

export const generateRandomBytes = (s: number) => {
  const id = (uuid.v4() + uuid.v4()).replace(/-/g, '');
  return id.slice(0, s);
};

export const sortByField = ({
  items,
  field,
  sortDirection = 'asc',
  locale = 'en',
}: {
  items: Record<string, unknown>[];
  field: string;
  sortDirection?: string;
  locale?: string;
}) => {
  if (!Array.isArray(items)) return [];

  return [...items].sort((a, b) => {
    const aValue = a[field];
    const bValue = b[field];

    if (aValue == null && bValue == null) return 0;
    if (aValue == null) return sortDirection === 'asc' ? 1 : -1;
    if (bValue == null) return sortDirection === 'asc' ? -1 : 1;

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortDirection === 'asc'
        ? aValue.localeCompare(bValue, locale, { sensitivity: 'base' })
        : bValue.localeCompare(aValue, locale, { sensitivity: 'base' });
    }

    return sortDirection === 'asc' ? (aValue > bValue ? 1 : aValue < bValue ? -1 : 0) : bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
  });
};

export const trimFields = <T>(data: T): T => {
  if (data === null || data === undefined) {
    return data;
  }

  if (typeof data === 'string') {
    return data.trim();
  }

  if (Array.isArray(data)) {
    return data.map((item) => trimFields(item));
  }

  if (typeof data === 'object') {
    const trimmedObject: Record<string, unknown> = {};
    for (const key in data) {
      if ((data as Record<string, unknown>).hasOwnProperty(key)) {
        trimmedObject[key] = trimFields((data as Record<string, unknown>)[key]);
      }
    }
    return trimmedObject as T;
  }

  return data;
};

export const compareShallowPrimitiveValues = (obj1: Record<string, unknown>, obj2: Record<string, unknown>) => {
  for (const key of Object.keys(obj1)) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};

export const getValueByPath = (obj: Record<string, unknown>, path: string) => {
  return path.split('/').reduce((acc, key) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return acc[key];
    }
    return undefined;
  }, obj);
};

export const filterByKeys = ({ items, search, keys }: { items: Record<string, unknown>[]; search: string; keys: string[] }) => {
  if (!search) return items;

  const lowerSearch = search.toLowerCase();

  return items.filter((item) =>
    keys.some((key) => {
      const value = key.split('/').reduce((acc, k) => acc?.[k], item);
      return value?.toString().toLowerCase().includes(lowerSearch);
    })
  );
};

export const deepClone = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));
